import React from "react";

/**
 * A tooltipped Switch/Button/IconButton must blur itself after firing, or the
 * tooltip gets stuck open (vault/how-to/how-to-build-new-module.md:1336 — Chakra's
 * Tooltip opens on hover AND focus; the click closes it, the focus that follows
 * reopens it, and the control keeps focus until the user clicks elsewhere).
 *
 * Exempt: controls that navigate away or open a modal/AlertDialog — the dialog
 * steals focus and closes the tooltip by itself.
 */
export function blurClick<E extends HTMLElement = HTMLElement>(
  fn?: (e: React.MouseEvent<E>) => void,
): (e: React.MouseEvent<E>) => void {
  return (e) => {
    e.currentTarget?.blur?.();
    fn?.(e);
  };
}

/** Same idea for a Switch / Checkbox `onChange` — the event target is the input. */
export function blurChange<E extends HTMLInputElement = HTMLInputElement>(
  fn?: (e: React.ChangeEvent<E>) => void,
): (e: React.ChangeEvent<E>) => void {
  return (e) => {
    (e.target as HTMLElement)?.blur?.();
    fn?.(e);
  };
}
